import { useStaticQuery } from 'gatsby';
var getSiteMetadata = function getSiteMetadata() { var _useStaticQuery$site; return ((_useStaticQuery$site = useStaticQuery("1080485468").site) === null || _useStaticQuery$site === void 0 ? void 0 : _useStaticQuery$site.siteMetadata) || {}; };
export default getSiteMetadata;
